import { UserRoles } from '@state';
import { useRecoilValue } from 'recoil';

export const useHasRole = (role: string) => {
	const roles = useRecoilValue(UserRoles);
	return roles.some((r) => r === role);
}
